import './hero.scss'
import './hero-research-module.scss'

const selectors = {
  researchModule: '[data-hrm]',
  researchModuleTrigger: '[data-hrm-trigger]',

  researchModuleValues: '[data-hrm-values]',
  researchModuleValuesParameter: '[data-hrm-values-parameter]',
  researchModuleValuesContainer: '[data-hrm-values-container]',

  researchModuleAccordion: '[data-hrm-accordion]',

  researchModuleTabs: '[data-hrm-tabs]',
  researchModuleTabsHeader: 'data-hrm-tabs-header',
  researchModuleTabsPane: 'data-hrm-tabs-pane',

  input: 'input',

  active: 'active',
  itemSelected: 'item-selected',
  loading: 'loading',
}

const checkAvailableFilters = (panes, activeIndex = 0) => {
  const form = document.querySelector('[data-hrm] form')
  const formValues = new FormData(form)
  const params = [...formValues.entries()].reduce((res, [name, value]) => [...res, `${name}=${value}`], []).join('&')
  formValues.append('params', params)
  formValues.append('action', 'home_filter')
  formValues.append('nonce', window['ajax_settings'].nonce)
  //if (!params) return
  panes[activeIndex].classList.add(selectors.loading)

  const url = window['ajax_settings'].url
  fetch(url, {
    method: 'POST',
    credentials: 'same-origin',
    body: formValues,
  })
    .then((res) => {
      return res.json()
    })
    .then((res) => {
      //console.log('res', res)
      const inputs = document.querySelectorAll('input[type="checkbox"]')
      inputs.forEach((input) => {
        const isAvailable = res[input.name].includes(input.value)

        if (isAvailable) input.removeAttribute('disabled')
        else input.setAttribute('disabled', '')
      })
    })
    .finally(() => {
      panes[activeIndex].classList.remove(selectors.loading)
      
    })
}

const checkSelectedValues = (item) => {
  const values = item.querySelector(selectors.researchModuleValuesContainer)?.dataset.hrmValuesContainer

  item.classList[!!values ? 'add' : 'remove'](selectors.itemSelected)
}

const handleAccordionClick = (accordions, activeIndex) => {
  accordions.forEach((accordion, index) => {
    const isActive = accordion.getAttribute('data-hrm-accordion')

    accordion.setAttribute('data-hrm-accordion', activeIndex === index ? (!isActive ? selectors.active : '') : '')

    checkSelectedValues(accordion)
  })

  checkAvailableFilters(accordions, activeIndex)
}

const initAccordions = (accordions) => {
  accordions?.forEach((accordion, activeIndex) => {
    const accordionHeader = accordion.firstElementChild

    accordionHeader.addEventListener('click', () => handleAccordionClick(accordions, activeIndex))
  })
}

const initCheckboxes = (checkboxes) => {
  let checkboxesChecked = [];
  checkboxes.forEach((input) => {
    input.addEventListener('change', (e) => {
      const value = e.target.dataset.label
      const valueContainers = document.querySelectorAll(`[data-hrm-values="${e.target.dataset.parameter}"] ${selectors.researchModuleValuesContainer}`)

      valueContainers.forEach((container) => {
        const selectedValues = container.dataset.hrmValuesContainer.split(', ')

        if (e.target.checked) {
          container.setAttribute('data-hrm-values-container', [...selectedValues, value].filter((i) => !!i).join(', '))
          container.innerText = [...selectedValues, value].filter((i) => !!i).join(', ')
        } else {
          container.setAttribute('data-hrm-values-container', selectedValues.filter((i) => !!i && i !== value).join(', '))
          container.innerText = selectedValues.filter((i) => !!i && i !== value).join(', ')
        }
      })

      // check selected checkboxes
      if (e.target.checked) {
        checkboxesChecked.push(e.target);  
      } else {
        checkboxesChecked = checkboxesChecked.filter(el => el !== e.target);
      }
      if (!checkboxesChecked.length) {
        const panes = document.querySelectorAll(`.hrm__form-panes > [${selectors.researchModuleTabsPane}]`)
        let activeIndex = 0;
        panes.forEach((pane, index) => {
          if (pane.classList.contains(selectors.active)) {
            activeIndex = index;
          }
        })
        checkAvailableFilters(panes, activeIndex);
      }
    })
  })
}

const handleTabClick = (headers, panes, activeIndex) => {
  headers.forEach((header, index) => {
    header.classList[index === activeIndex ? 'add' : 'remove'](selectors.active)

    checkSelectedValues(header)
  })
  
  panes.forEach((pane, index) => pane.classList[index === activeIndex ? 'add' : 'remove'](selectors.active))

  let parentActiveIndex = 0;
  const parentPanes = document.querySelectorAll(`.hrm__form-panes > [${selectors.researchModuleTabsPane}]`)
  
  parentPanes.forEach((pane, index) => {
    if (pane.classList.contains(selectors.active)) {
      parentActiveIndex = index;
    }
  })

  checkAvailableFilters(parentPanes, parentActiveIndex)
}

const initTabs = (tabs) => {
  const headers = tabs.querySelectorAll(`[${selectors.researchModuleTabsHeader}="${tabs.dataset.hrmTabs}"]`)
  const panes = tabs.querySelectorAll(`[${selectors.researchModuleTabsPane}="${tabs.dataset.hrmTabs}"]`)

  headers.forEach((header, activeIndex) => {
    header.addEventListener('click', () => handleTabClick(headers, panes, activeIndex))
  })

  handleTabClick(headers, panes, 0)
}

const initResearchModule = (researchModule) => {
  const accordions = researchModule.querySelectorAll(selectors.researchModuleAccordion)
  const tabs = researchModule.querySelectorAll(selectors.researchModuleTabs)
  const checkboxes = researchModule.querySelectorAll(selectors.input)

  tabs.forEach(initTabs)

  initAccordions(accordions)
  initCheckboxes(checkboxes)
}

const initResearchModuleTriggers = (researchModule, triggers) => {
  triggers.forEach((trigger) =>
    trigger.addEventListener('click', () => {
      researchModule.classList.toggle(selectors.active)
      document.body.classList.toggle('no-scroll')
    })
  )
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    const researchModule = document.querySelector(selectors.researchModule)
    const triggers = document.querySelectorAll(selectors.researchModuleTrigger)

    if (!researchModule || !triggers) return

    initResearchModule(researchModule)
    initResearchModuleTriggers(researchModule, triggers)
  },
  { once: true }
)
